import {
  apiClient,
  type BulkUpdateDeliveryStatusResultEntity
} from '@/libs/api'
import { type ShipmentDeliveryStatusType } from '@/libs/api/types'

export type BulkUpdateDeliveryStatusRequest = {
  tenantKey: string
  ids: number[]
  deliveryStatus: ShipmentDeliveryStatusType
}

export const bulkUpdateDeliveryStatus = async ({
  tenantKey,
  ids,
  deliveryStatus
}: BulkUpdateDeliveryStatusRequest): Promise<BulkUpdateDeliveryStatusResultEntity> => {
  const response = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.bulk_delivery_status.$put({
      body: { ids, deliveryStatus }
    })
  return response.data
}
